var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart",style:({ 'height': _vm.height })},[_c('v-chart',{ref:"chart",staticStyle:{"overflow":"initial"},attrs:{"option":_vm.options,"update-options":{ notMerge: true },"init-options":{ renderer: 'svg' }},on:{"legendselectchanged":_vm.handleLegendSelectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }